import CryptoJS from "crypto-js";

// 接口签名生成方法
export const sort_ASCII = (obj) => {
  let arr = new Array();
  let num = 0;
  const secret = "TKGKItgT";
  for (let i in obj) {
    arr[num] = i;
    num++;
  }
  let sortArr = arr.sort();
  sortArr = sortArr.map((item) => {
    return `${item}=${encodeURIComponent(obj[item])}`;
  });
  let sortString = `${sortArr.join("&")}${secret}`;
  return CryptoJS.MD5(sortString).toString().toLowerCase();
};

export const sort_ASCII1 = (obj) => {
  let arr = new Array();
  let num = 0;
  const secret = "TKGKItgT";
  for (let i in obj) {
    arr[num] = i;
    num++;
  }
  let sortArr = arr.sort();
  sortArr = sortArr.map((item) => {
    return `${item}=${obj[item]}`;
  });
  let sortString = `${sortArr.join("&")}${secret}`;
  return CryptoJS.MD5(sortString).toString().toLowerCase();
};

// 自定义SET
export const SET = function () {
  this.arr = [];
};

SET.prototype.push = function (res) {
  const num = this.arr.length;
  let flag = false;
  if (num === 0) return this.arr.push(res);
  for (let i = 0; i < num; i++) {
    if (this.arr[i] === res) flag = true;
  }
  if (flag) return this.arr;
  return this.arr.push(res);
};

SET.prototype.remove = function (res) {
  const num = this.arr.length;
  for (let i = 0; i < num; i++) {
    if (this.arr === res) this.arr.splice(i, 1);
  }
  return;
};

// 截取hostname方法
export const cutHostName = (name) => {
  const end = name.indexOf("/", 1) === -1 ? name.length : name.indexOf("/", 1);
  const hostname = name.substring(0, end);
  return hostname;
};

/**
 * 版本号对比
 * @param {String} version_1 当前版本号
 * @param {String} version_2 需要比对版本号
 * @return {Boolean} 当前版本号是否大于等于需要比对的版本号
 */
export function versionCompare(version_1, version_2) {
  let v1 = version_1;
  let v2 = version_2;
  try {
    v1 = v1.split(".");
    v2 = v2.split(".");
    if (Number(v1[0]) > Number(v2[0])) {
      return true;
    } else {
      if (Number(v1[0]) === Number(v2[0])) {
        if (Number(v1[1]) > Number(v2[1])) {
          return true;
        } else if (
          Number(v1[1]) === Number(v2[1]) &&
          Number(v1[2]) >= Number(v2[2])
        ) {
          return true;
        }
      }
    }
    return false;
  } catch (error) {
    console.log(268, error);
    return false;
  }
}

/**
 * 因安全需要，需根据请求参数生成加密token
 * @param {*} params 请求参数
 * @param {*} key 加密key
 */
export function addParamsToken(params, KEY = "wx_box") {
  let sortArr = [];
  for (const key in params) {
    if (Object.hasOwnProperty.call(params, key)) {
      sortArr.push(key);
    }
  }
  sortArr.sort();
  let paramsStr = "";
  for (const i of sortArr) {
    paramsStr += i + ":" + params[i];
  }
  paramsStr += KEY;
  let str = CryptoJS.MD5(paramsStr).toString();
  return {
    params,
    token: str,
  };
}

// 检查是不是微信浏览器
export function checkIsWxBrowser() {
  //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  const ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  let result = ua.match(/MicroMessenger/i) == "micromessenger";
  return result;
}

// 获取cookie对应key下的数据
// 模拟数据 cookie = 'Domain=.hzwxbz999.cn; params={"androidid":"c1064486a6fe3139","appid":"200010949","bundleid":"com.hzwx.wx.box","channelId":"null","deviceId":"215901CF62ED4AA6B00B404AE09075369f54e6a276807a7628f847e895c2026e","deviceName":"OPPO PCHM10","devicetype":"PCHM10","imei":"null","inip":"172.16.56.26","mac":"null","network":"WIFI","oaid":"215901CF62ED4AA6B00B404AE09075369f54e6a276807a7628f847e895c2026e","op":"null","os":"android","osversion":"11","registerTime":0,"systemVersion":"11","userId":"null","uuid":"ffffffff-c928-5408-ffff-ffffc9285408"}'
export const getCookie = (key = "params") => {
  let keyReg = key + "=";
  let data = null;
  let cookie = document.cookie;
  let cookieItemArr = cookie.split(";");
  for (const item of cookieItemArr) {
    let curItem = item.trim();
    if (curItem.indexOf(keyReg) === 0) {
      data = curItem.substring(keyReg.length);
    }
  }
  try {
    data = JSON.parse(data);
    return data;
  } catch (error) {
    return data;
  }
};

const merge = (left, right, key) => {
  let result = [];
  while (left.length && right.length) {
    if (left[0][key] < right[0][key]) {
      result.push(left.shift());
    } else {
      result.push(right.shift());
    }
  }
  while (left.length) {
    result.push(left.shift());
  }
  while (right.length) {
    result.push(right.shift());
  }

  return result;
};

// 用户数组排序
export const arraySort = (array, key = "sort") => {
  if (Array.isArray(array)) {
    // 采取归并排序
    let len = array.length;
    if (len < 2) {
      return array;
    }
    let middle = Math.floor(len / 2);
    let left = array.slice(0, middle);
    let right = array.slice(middle);
    // 递归分治法
    return merge(arraySort(left, key), arraySort(right, key), key);
  } else {
    return array;
  }
};

/**
 * 执行下载操作
 * @param {*} targetUrl 目标url
 */
export const downloadTarget = (targetUrl) => {
  if (!targetUrl) {
    return;
  }
  window.open(targetUrl, "_blank");
};

export const pageLoseTips = (toastFunc) => {
  if (toastFunc) {
    toastFunc("页面走丢了，请检查链接地址重试");
  }
};

/**
 * 检查是否可以展示console插件
 * @returns visible true|false
 */
export function onCheckHasConsole() {
  let visible = false;
  const locationHost = window.location.hostname;
  const hosts = [
    "localhost",
    "172.16.20.29",
    "wxhdtest.hzwxbz999.cn",
    "wxhdpre.hzwxbz999.cn",
  ];
  if (hosts.includes(locationHost)) {
    visible = true;
  }
  return visible;
}

/**
 * iv向量转换为字符串
 * @param {*} array 
 * @returns 
 */
export const getStrFromBytes = (array) => {
  let r = '';
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    r += String.fromCharCode(element);
  }
  return r;
}

/**
 * des算法解密内容
 * @param {*} key 秘钥
 * @param {*} iv 偏移量
 * @param {*} message 待解密内容
 * @returns 已解密内容
 */
export const decryptDes = (key, iv, message) => {
  // console.log("待解密:",message);
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const ivHex = CryptoJS.enc.Utf8.parse(iv);
  let res = '';
  let decrypted = CryptoJS.DES.decrypt(
    {
      ciphertext: CryptoJS.enc.Base64.parse(message)
    }, 
    keyHex, 
    {
      iv: ivHex,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  res = decrypted.toString(CryptoJS.enc.Utf8);
  // console.log("解密结果:",res);
  return res;
}

/**
 * des算法解密内容
 * @param {*} key 秘钥
 * @param {*} iv 偏移量
 * @param {*} message 待解密内容
 * @returns 已解密内容
 */
export const encryptDes = (key, iv, message) => {
  // console.log("待加密:",message);
  const keyHex = CryptoJS.enc.Utf8.parse(key);
  const ivHex = CryptoJS.enc.Utf8.parse(iv);
  let res = '';
  let encrypted = CryptoJS.DES.encrypt(
    JSON.stringify(message), 
    keyHex, 
    {
      iv: ivHex,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  res = encrypted.toString();
  // console.log("加密结果:",res);
  return res;
}

export const PAGE_SIZE = 10;
export const getListTotalPage = (total, SIZE = PAGE_SIZE) => {
  let totalPage = 1;
  if (total > SIZE) {
    const num = total / SIZE;
    const truncNum = Math.trunc(total / SIZE);
    if (num === truncNum) {
      totalPage = num;
    } else {
      totalPage = truncNum + 1;
    }
  }
  return totalPage;
};

export const formatMinutes = (minutes) => {
  const days = Math.floor(minutes / (60 * 24));
  const hours = Math.floor((minutes % (60 * 24)) / 60);
  const remainingMinutes = minutes % 60;
  let result = "";
  if (days > 0) {
    result += days + "天";
  }
  if (hours > 0) {
    result += hours + "时";
  }
  if (remainingMinutes > 0) {
    result += remainingMinutes + "分";
  }
  return result;
}


export const isAndroid = () => {
  let u = navigator.userAgent;
  return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
}

export const isPC = () => {
  const userAgent = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  return !isMobile;
}

export const getSearchParams = (key) => {
  if (!key) return ''
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  const paramValue = params.get(key);
  return paramValue
}